export default __webpack_public_path__ + "static/home-face-6029a186e5ede5ec62ef8a746b4d71be.png";